import { IAvalancheDangerScale } from 'redux-state/avalanche-advisory/types.js';

const getDangerConfig = (
  scale?: IAvalancheDangerScale,
): {
  className: string;
  risk: string;
} => {
  if (scale && scale.danger_id >= 1) {
    return {
      className: `level-${scale?.danger_id}`,
      risk: scale.level.toUpperCase(),
    };
  }

  return {
    className: 'level-0',
    risk: 'NO RATING',
  };
};

export { getDangerConfig };
